export default [
    {
        path: '/good/list',
        name: '商品列表',
        component: () => import('@/views/shop/GoodList'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/good/detail/:id',
        name: '商品详情',
        component: () => import('@/views/shop/GoodCon'),
        meta: { breadNumber: 2 }
    },
    {
        path: '/cart',
        name: '购物车',
        component: () => import('@/views/shop/Cart'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/brand',
        name: '品牌街',
        component: () => import('@/views/shop/Brand'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/shop_street',
        name: '店铺街',
        component: () => import('@/views/shop/ShopStreet'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/shop/:id',
        name: '店铺详情',
        component: () => import('@/views/shop/Shop'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/shop/goods_list/:id',
        name: '店铺商品',
        component: () => import('@/views/shop/ShopGoodList'),
        meta: { breadNumber: 3 }
    },
    {
        path: '/shop_apply',
        name: '商户入驻',
        component: () => import('@/views/shop/ShopApply'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/point/shop',
        name: '积分商城',
        component: () => import('@/views/point/PointShop.vue'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/point/detail/:id',
        name: '积分商品',
        component: () => import('@/views/point/PointDetail.vue'),
        meta: { breadNumber: 2 }
    }
];
